import { authHeader, handleError } from '../helper';
import APIHelper from '../common/ApiHelper';
import APIURLConstants from '../common/ApiURLConstants';
import axios from 'axios';

export const revampScoutDashboardService = {
    getRevampScoutDashboardData,
    getRevampScoutDashboardCategoryDetail,
    exportRevampScoutDashboardExcel,
};

function getRevampScoutDashboardCategoryDetail(data) {
    return APIHelper.post(APIURLConstants.GET_REVAMP_SCOUT_DASHBOARD_CATEGORY_DETAIL, data, authHeader())
        .then(response => response)
        .catch(handleError);
}

const webAPIURL = () => {
    let url = `${new URL(window.location.origin)}api`;
    return url;
};

function getRevampScoutDashboardData(data) {
    return APIHelper.post(APIURLConstants.GET_REVAMP_SCOUT_DASHBOARD_DATA, data, authHeader())
        .then(response => response)
        .catch(handleError);
}

function exportRevampScoutDashboardExcel(data) {
    let headers = authHeader();
    headers.responseType = 'blob';
    const apiURL = webAPIURL();

    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            responseType: 'arraybuffer',
            url: apiURL + APIURLConstants.EXPORT_REVAMP_SCOUT_DASHBOARD_EXCEL,
            data: data,
            headers: headers,
        })
            .then(response => resolve(response))
            .catch(err => reject(err));
    });
}
